module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_75000_100000.0a821115.png";